import React, { PropsWithChildren } from 'react';

export default function AkSmaller({ children }: PropsWithChildren<{}>) {
    return (
        <span style={{ fontSize: '50%', alignSelf: 'center', fontWeight: '400' }}>{children}</span>
    );
}
